<template>
  <div>
    <div class="container-fluid">
      <div class="page-header">
        <div class="row">
          <div class="col-sm-6">
            <h3>{{ $t("expertBenefits") }}</h3>
            <ol class="breadcrumb">
              <li class="breadcrumb-item"><a href="/">{{ $t("general") }}</a></li>
              <li class="breadcrumb-item active">{{ $t("expertBenefit_management") }}</li>
            </ol>
          </div>
          <div class="col-sm-6">
            <!-- Bookmark Start-->
            <div class="bookmark">
              <ul>
                <li><a href="javascript:void(0)" data-container="body" data-bs-toggle="popover" data-placementType="top"
                    title="" data-original-title="Tables"><i data-feather="inbox"></i></a></li>
                <li><a href="javascript:void(0)" data-container="body" data-bs-toggle="popover" data-placementType="top"
                    title="" data-original-title="Chat"><i data-feather="message-square"></i></a></li>
                <li><a href="javascript:void(0)" data-container="body" data-bs-toggle="popover" data-placementType="top"
                    title="" data-original-title="Icons"><i data-feather="command"></i></a></li>
                <li><a href="javascript:void(0)" data-container="body" data-bs-toggle="popover" data-placementType="top"
                    title="" data-original-title="Learning"><i data-feather="layers"></i></a></li>
                <li><a href="javascript:void(0)"><i class="bookmark-search" data-feather="star"></i></a>
                  <form class="form-inline search-form">
                    <div class="form-group form-control-search">
                      <input type="text" :placeholder="$t('search') + '...'">
                    </div>
                  </form>
                </li>
              </ul>
            </div>
            <!-- Bookmark Ends-->
          </div>
        </div>
      </div>
    </div>
    <!-- Container-fluid starts-->
    <div class="container-fluid">
      <div class="row">
        <div class="col-9">
          <div class="card">
            <div class="card-header pb-0">
              <h5 v-if="editMode">{{ $t("edit_expertBenefit") }}</h5>
              <h5 v-else>{{ $t("create_expertBenefit") }}</h5>
            </div>
            <LanguagePicker v-model="selectedLanguage" />
            <div class="card-body">
              <div class="form theme-form">
                <div class="row">
                  <div class="col">
                    <div class="mb-3">
                      <label>{{ $t("description") }}*</label>
                      <v-textarea v-model="expertBenefit.descriptions[selectedLanguage]"
                        class="datainput justify-content-end align-self-center pb-1" dense outlined
                        hide-details="auto"></v-textarea>
                    </div>
                  </div>
                  <div class="col">
                    <div class="mb-3">
                      <label>{{ $t("image") }}*</label>
                      <Upload v-model="expertBenefit.images[selectedLanguage]" :label="''"></Upload>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <div class="mb-3">
                      <label>{{ $t("targetURL") }}*</label>
                      <v-text-field v-model="expertBenefit.links[selectedLanguage]"
                          class="datainput justify-content-end align-self-center pb-1" dense outlined
                          hide-details="auto" dence></v-text-field>
                    </div>
                  </div>
                  <div
                    v-show="$rights.includes('TENANT_INDEPENDENCE')"
                    class="col"
                  >
                    <div class="mb-3 w-100">
                      <label>{{ $t("tenant") }}</label>
                      <v-select
                        class="mt-0 pt-0"
                        v-model="expertBenefit.tenantId"
                        :items="tenants"
                        item-text="name"
                        item-value="id"
                        append-icon=""
                        hide-details
                      >
                        <template slot="item" slot-scope="data">
                          {{ data.item.name }}
                        </template>
                        <template slot="selection" slot-scope="data">
                          {{ data.item.name }}
                        </template>
                      </v-select>
                    </div>
                  </div>
                </div>
                <button style="float: right;" @click="save()" class="btn btn-primary" type="button"
                  data-bs-original-title="" title="">{{ $t("save") }}</button>
                <button class="btn btn-secondary mr-2" style="float: right;" @click="$routerBack()">{{
                  $t("cancel")
                }}</button>
              </div>
            </div>
          </div>

        </div>
        <div class="col-3">
          <div class="card">
            <div class="card-header pb-0">
              <h5>{{ $t("actions") }}</h5>
            </div>
            <div class="card-body" v-if="editMode">
              <button @click="showDeleteConfirmation = true" class="btn btn-danger" type="button"
                data-bs-original-title="" title="">{{ $t("delete_expertBenefit") }}</button>
            </div>
            <div class="card-body" v-else>
              <p>{{ $t("BENEFIT_SAVE_BEFORE_DELETE_HINT") }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Container-fluid Ends-->
    <div class="modal fade show" v-show="showDeleteConfirmation" tabindex="-1" aria-labelledby="exampleModalCenter"
      style="display: block; padding-right: 17px; background: rgba(0,0,0,.5);" aria-modal="true" role="dialog">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ $t("delete_expertBenefit") }}</h5>
            <button class="btn-close" type="button" data-bs-dismiss="modal" aria-label="Close" data-bs-original-title=""
              title="" @click="(showDeleteConfirmation = false)"></button>
          </div>
          <div class="modal-body">
            <p>{{ $t("confirm_delete_expertBenefit") }}</p>
          </div>
          <div class="modal-footer">
            <button @click="(showDeleteConfirmation = false)" class="btn btn-secondary" type="button"
              data-bs-dismiss="modal" data-bs-original-title="" title="">{{ $t("cancel") }}</button>
            <button @click="deletePlacementType()" class="btn btn-danger" type="button" data-bs-original-title=""
              title="">{{ $t("delete") }}</button>
          </div>
        </div>
      </div>

    </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import { MapPinIcon, PlusSquareIcon } from 'vue-feather-icons'

export default {

  props: {
    expertBenefitId: Number,
  },

  components: {
    apexcharts: VueApexCharts,
    MapPinIcon,
    PlusSquareIcon,
  },
  data() {
    return {
      editMode: false,

      routes: {
        expertBenefits: "/api/expertBenefit",
      },

      expertBenefit: {
        descriptions: {},
        links: {},
        images: {},
        tenantId: null,
      },

      selectedLanguage: "en",

      showDeleteConfirmation: false,

      map: {
        center: {
          latitude: 52.218945,
          longitude: 13.439067
        },
        zoom: 10,
        url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
        attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      },

      boundaries: [],
    };
  },

  mounted() {
    this.selectedLanguage = this.$locale;
    if (this.expertBenefitId != null) {
      this.editMode = true;
      this.fetchEditingExpertBenefit();
    } else {
    }

    if(this.$rights.includes("TENANT_INDEPENDENCE")){
      this.fetchTenants();
    }
  },

  methods: {
    fetchTenants() {
      var _this = this;
      this.$axios
        .get("/api/tenant")
        .then(function (response) {
          _this.tenants = response.data.content;
          _this.$forceUpdate();
        })
        .catch(this.onError);
    },
    fetchEditingExpertBenefit() {
      var _this = this;
      this.$axios
        .get("/api/expertBenefit/" + this.expertBenefitId)
        .then(function (response) {
          _this.expertBenefit = response.data;
          _this.expertBenefit.descriptions = response.data.descriptionsMap;
          _this.expertBenefit.images = response.data.imagesMap;
          _this.expertBenefit.links = response.data.linksMap;
        })
        .catch(this.onError);
    },
    
    save() {
      var expertBenefit = Object.assign({}, this.expertBenefit);
      var obj = expertBenefit.images;
      for (const [key, value] of Object.entries(obj)) {
        if(Array.isArray(obj[key]) && obj[key].length == 0){
          obj[key] = null;
        }else if(Array.isArray(obj[key]) && obj[key].length == 1){
          obj[key] = obj[key][0];
        }
      }
      if (this.editMode) {
        this.updatePlacementType(expertBenefit);
      } else {
        this.createPlacementType(expertBenefit);
      }
    },
    createPlacementType(expertBenefit) {
      var _this = this;
      this.$axios
        .post("/api/expertBenefit", expertBenefit)
        .then(function (response) {
          _this.$noty.success(_this.$t("expertBenefit_created"));
          _this.$router.push("/benefits");
        })
        .catch(this.onError);
    },
    updatePlacementType(expertBenefit) {
      var _this = this;
      this.$axios
        .put("/api/expertBenefit/" + this.expertBenefitId, expertBenefit)
        .then(function (response) {
          _this.$noty.success(_this.$t("expertBenefit_updated"));
          _this.$router.push("/benefits");
        })
        .catch(this.onError);
    },
    deletePlacementType() {
      var _this = this;
      this.$axios
        .delete("/api/expertBenefit/" + this.expertBenefitId)
        .then(function (response) {
          _this.showDeleteConfirmation = false;
          _this.$noty.success(_this.$t("expertBenefit_deleted"));
          _this.$router.push("/benefits");
        })
        .catch(this.onError);
    },
    logError(error) {
      console.log(error);
    },
    onError(err) {
      if (
        err.response != null &&
        err.response.data != null
      ) {
        this.$noty.error(err.response.data);
      } else {
        console.error(err);
      }
    },
    finalize() {
      progressIndicator.hidden = true;
    }
  },
};
</script>

<style>

</style>